"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollLock = void 0;
const react_1 = require("react");
const useScrollLock = () => {
    const loadingRef = (0, react_1.useRef)(false);
    const concurrencySafe = (callback) => __awaiter(void 0, void 0, void 0, function* () {
        if (!loadingRef.current) {
            loadingRef.current = true;
            yield callback();
            loadingRef.current = false;
        }
    });
    return {
        concurrencySafe,
    };
};
exports.useScrollLock = useScrollLock;
